import { render } from "react-dom";
import { createElement } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import { Root } from "./Root.fs.js";

render(createElement(Auth0Provider, {
    domain: "dev-wecheck.eu.auth0.com",
    clientId: "V4fZAAd2F2Yv5JYuUOvHi3iR3CGBbBo2",
    redirectUri: window.location.origin,
    children: createElement(Root, null),
}), document.getElementById("feliz-app"));

